<script lang="ts">
	import { Col, Row, Text } from '@Shelly/shelly-design-system';
	import LottiePlayer from 'src/components/LottiePlayer/LottiePlayer.svelte';
	import { format } from 'svelte-i18n';
</script>

<Text element="h2" class="mb-xs">
	{$format('presence_wizard_zones_title', { default: 'Detection zones' })}
</Text>
<p class="step-subtitle mb-l">
	{$format('presence_wizard_zones_subtitle', {
		default:
			'Zones let different areas of your room trigger automations independently — for example, a desk zone for work mode and a couch zone for movie mode.',
	})}
</p>

<Row class="d-flex align-items-center">
	<Col sm="12" md="6" lg="6" class="d-flex justify-content-center">
		<LottiePlayer
			src="/images/lottie/radar/MakeZone.json"
			autoplay={true}
			loop={true}
			height={220}
			width={220}
			background="transparent"
		/>
	</Col>
	<Col sm="12" md="6" lg="6">
		<div class="zones-points">
			<div class="point">
				<i class="fas fa-circle-check point-icon" aria-hidden="true"></i>
				<p>
					{$format('presence_wizard_zones_point_1', {
						default: 'Draw up to 10 zones on the radar grid',
					})}
				</p>
			</div>
			<div class="point">
				<i class="fas fa-circle-check point-icon" aria-hidden="true"></i>
				<p>
					{$format('presence_wizard_zones_point_2', {
						default: 'Each zone reports occupancy independently',
					})}
				</p>
			</div>
			<div class="point">
				<i class="fas fa-circle-check point-icon" aria-hidden="true"></i>
				<p>
					{$format('presence_wizard_zones_point_3', {
						default: 'Name and colour each zone for easy identification',
					})}
				</p>
			</div>
			<div class="point">
				<i class="fas fa-circle-check point-icon" aria-hidden="true"></i>
				<p>
					{$format('presence_wizard_zones_point_4', {
						default: 'Use zone events in automations and scripts',
					})}
				</p>
			</div>
		</div>
	</Col>
</Row>

<style>
	.step-subtitle {
		color: var(--color-text-secondary, rgba(255, 255, 255, 0.55));
		line-height: 1.5;
	}

	.zones-points {
		display: flex;
		flex-direction: column;
		gap: 12px;
	}

	.point {
		display: flex;
		align-items: flex-start;
		gap: 10px;
		font-size: 13px;
		line-height: 1.45;
	}

	.point p {
		margin: 0;
	}

	.point-icon {
		flex-shrink: 0;
		margin-top: 1px;
		color: var(--color-success, #00d5b3);
		font-size: 15px;
	}
</style>
